import variables from '../../variables.module.scss';

const MuiTextField = (breakpoints) => ({
  styleOverrides: {
    root: {
      '&.steps-wizard-steps': {
        [`@media screen and (max-width: ${variables.breakpointMobile})`]: {
          margin: '10px 0',
        },
        '& p': {
          width: '150%',
          lineHeight: '1.1em',
          fontSize: '0.7rem',
          marginLeft: 0,
          marginTop: 5,
          [breakpoints.between('md', 'mediumscreen')]: {
            width: '115%',
          },
        },
        '&.answer-input': {
          input: {
            padding: 10,
            textAlign: 'center',
            fontSize: 24,
            fontWight: 100,
            fontFamily: variables.fontLight,
          },
          'input[type=number]': {
            MozAppearance: 'textfield',
          },
          'input[type=number]::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          'input::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          'input::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        },
        '&.answer-input-mt': {
          marginTop: 24,
        },
        '&.answer-input-mr': {
          marginRight: 50,
        },
        '&.answer-input-small': {
          maxWidth: 82,
          height: 56,
        },
        '&.answer-input-medium': {
          width: 162,
          height: 56,
        },
        '&.error-message-sm': {
          '& p': {
            width: '125%',
            [breakpoints.between('md', 'mediumscreen')]: {
              width: '115%',
            },
          },
        },
        '&.error-message-lg': {
          '& p': {
            width: '200%',
            [breakpoints.between('md', 'mediumscreen')]: {
              width: '120%',
            },
          },
        },
      },
    },
  },
});

export default MuiTextField;
